import { slugify } from '@i22team/td-longtail-vue-components';

export const cleanArticleNumber = (articleNumber: string) => slugify(articleNumber, true, true);

export const cleanCouponCode = (couponCode: string) => slugify(couponCode, true, true);
